export enum MediaSize {
  XXSSmall = 'xxs',
  XSmall = 'xs',
  Small = 's',
  SmallMedium = 'sm',
  Medium = 'm',
  Large = 'l',
  XLarge = 'xl',
}

export const MEDIA_SIZE_XXSMALL = MediaSize.XXSSmall;
export const MEDIA_SIZE_XSMALL = MediaSize.XSmall;
export const MEDIA_SIZE_SMALL = MediaSize.Small;
export const MEDIA_SIZE_SMALL_MEDIUM = MediaSize.SmallMedium;
export const MEDIA_SIZE_MEDIUM = MediaSize.Medium;
export const MEDIA_SIZE_LARGE = MediaSize.Large;
export const MEDIA_SIZE_XLARGE = MediaSize.XLarge;
